<template>
  <div class="date-field">
    <div class="date-field__fill">
      <span class="date-field__label">{{ label }}</span>

      <date-picker v-model="date" :default-value="initialDate"
      format="DD.MM.YYYY" type="date" @input="$emit('input', parsedDate)"></date-picker>

      <span v-if="!hasError" class="info">pp.kk.vvvv</span>
      <span v-if="hasError" class="error">{{ hasError }}</span>
    </div>
  </div>
</template>

<script>
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import 'vue2-datepicker/locale/fi';
  import moment from 'moment'

export default {
  name: "Datepicker",
    components: { DatePicker },

  props: {
    initialDate: {
      type: String,
      required: false
    },
    icon: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      required: true
    },
    hasError: {
      type: String,
      default: null
    }
  },
  mounted() {
    this.date = moment(this.initialDate,'DD.MM.YYYY').toDate();
  },
  computed: {
    parsedDate(){
      return moment(String(this.date)).format('DD.MM.YYYY')
    } 
  },
  data() {
    return {
      date: null,
    };
  },
};
</script>

<style lang="scss">
.date-field {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 0.5em;
  width: 50%;
  &__fill {
    position: relative;
    width: 100%;
  }
  i {
    width: 1.5em;
    height: 1.5em;
    margin-right: 1em;
  }
  &__input {
    width: 100%;
    padding: 1em 0 5px;
    border: 0;
    border-radius: 0;
    outline: 0;
    box-shadow: none;
    font-size: 1.6rem;
    color: black;
    background-color: transparent;
    border-bottom: 1px solid $whitegray;
    &::placeholder {
      opacity: 0;
      transition: $transition;
    }
    &:placeholder-shown:not(:focus)::placeholder {
      opacity: 0;
    }
    &:placeholder-shown:not(:focus) + label {
      font-size: 1.2rem;
      transform: translateY(15px);
      color: $gray;
    }
    &:focus {
      border-bottom: 1px solid $lightred;
    }
  }
  &__label {
    transform: translateY(0);
    font-size: 1.2rem;
    pointer-events: none;
    color: $lightred;
    transition: $transition;
  }
  .info {
    font-size: 1.2rem;
  }
}
</style>
